import 'whatwg-fetch';
import { middle_dev, middle_key_val } from 'config';
import { couponsWeb_controller } from 'config';
import { kiosko_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class UserService{
    static info() {
        /*
        *   @info
        *   Devuelve la informacion del usuario, restringidos por sesión activa
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/infoPersona`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static infoByCodLib(codLib) {
        /*
        *   @info
        *   Devuelve la informacion del usuario, restringidos por sesión activa
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${kiosko_controller}/infoPersona/${codLib}`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }

    static welcome() {
        /*
        *   @welcome
        *   Cambio el estado del popup de bienvenida, restringidos por sesión activa
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/welcome`,{
            method: 'POST',
            headers: authHeader
        }).then((data) => {
            return data.json()
        })
    }
}